var occurenceLookup = {
  init: function () {
    console.log("init of occurenceLookup");
    occurenceLookup.registerEventTrigger();
  },

  registerEventTrigger: function () {
    $("dt.lookup-occurence").on("click", occurenceLookup.lookupWord);
  },

  lookupWord: function () {
    var referer = window.location.pathname.toString().split('/');
    referer.shift();
    console.log(referer);

    var word = $(this).find("span:first-child").text();
    var xhr = $.ajax({
      method: "get",
      url: "/" + $(this).attr("data-lang") + "/occurence/" + word + '/' + referer[2] + '/' +referer[3],
      dataType: "html",
    });

    xhr.done(function (page) {
      $("#wordOccurenceModal .modal-body").html(page);

      let wordOccurenceModal = document.getElementById("wordOccurenceModal");
      var bsModal = new bootstrap.Modal(wordOccurenceModal);
      bsModal.show();
    });
  },
};

$(function () {
  if ($("dt.lookup-occurence").length > 0) {
    occurenceLookup.init();
  } else {
    occurenceLookup = null;
  }
});
